import { createSlice } from "@reduxjs/toolkit";
import { CONSTANTS as C } from "config";

const initialState = {
  settings: {},
  CatalogueType: C.BRAND_BASED,
  integrations: [],
  brand: null,
};

const SettingsReducer = createSlice({
  name: "settingReducer",
  initialState,
  reducers: {
    setSettings: (state, action) => {
      state.settings = action.payload;
    },
    updateCatalogueType: (state, action) => {
      state.CatalogueType = action.payload;
    },
    setIntegrations: (state, action) => {
      state.integrations = action.payload;
    },
    setBrand:(state, action) => {
      state.brand = action.payload;
    },
  },
});

export const {
  setSettings,
  updateCatalogueType,
  setIntegrations,
  setBrand,
} = SettingsReducer.actions;
export default SettingsReducer.reducer;
